import { useEffect, useState } from 'react';
import { collection, query, orderBy, limit as qLimit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase.js';

const DEFAULT_ORDER_BY_COLLECTION = {
  events: 'occurred_at',
  emails: 'created_at',
  contacts: 'created_at',
  campaigns: 'created_at',
  links: 'created_at',
  pdfs: 'created_at',
  views: 'created_at',
  svgs: 'created_at',
};

export function useCollection(name, { order, direction = 'desc', max = 200 } = {}) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const effectiveOrder = order || DEFAULT_ORDER_BY_COLLECTION[name] || 'created_at';
  useEffect(() => {
    const q = query(collection(db, name), orderBy(effectiveOrder, direction), qLimit(max));
    return onSnapshot(
      q,
      (snap) => {
        setDocs(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('useCollection', name, err);
        setLoading(false);
      },
    );
  }, [name, effectiveOrder, direction, max]);
  return { docs, loading };
}
